<mbs-modal
  [showOkButton]="false"
  [title]="'shared:unable-emails-modal.title' | i18next">
  <ng-container modal-body>
    <div class="fw-bold">{{ 'shared:unable-emails-modal.hints.reasonForBeingAddedToTheBounceList' | i18next }}</div>
    <span>{{ 'shared:unable-emails-modal.hints.dueToContinuousBounces' | i18next }}</span>

    <div class="fw-bold mt-2">{{ 'shared:unable-emails-modal.hints.action' | i18next }}</div>
    <span>{{ 'shared:unable-emails-modal.hints.pleaseReviewYourEmail' | i18next }}</span>
    <a
      [helpLink]="'/organization/settings/email-service'"
      target="_blank"
      >{{ 'shared:unable-emails-modal.buttons.learnMore' | i18next }}</a
    >

    <mbs-table-grid
      [data]="emails"
      [disableViewSwitch]="true"
      [headers]="headers"
      [loading]="loading || removeLoading"
      [maxHeight]="'500px'"
      class="mt-2">
      <ng-template
        let-value
        mbsTableCell>
        <mbs-text-ellipsis
          [tooltip]="value.email || '-'"
          placement="left">
          {{ value.email }}
        </mbs-text-ellipsis>
      </ng-template>

      <ng-template
        let-value
        mbsTableCell>
        {{ getReason(value.type) }}
        <mbs-button
          (click)="redirectToLogs(value.email)"
          [isCtrl]="true"
          >{{ 'shared:unable-emails-modal.buttons.showDetails' | i18next }}
        </mbs-button>
      </ng-template>

      <ng-template
        let-value
        mbsTableCell>
        <mbs-button
          (click)="removeFromBounceList(value.email)"
          [type]="'secondary'"
          >{{ 'shared:unable-emails-modal.buttons.unblock' | i18next }}
        </mbs-button>
      </ng-template>
    </mbs-table-grid>
  </ng-container>
</mbs-modal>
